import ReactPlayer from 'react-player/youtube'
import styled from '@emotion/styled'

import { Loader } from 'components/ui/Loader'
import theme from 'styles/theme'

export const PlayerWrapper = styled.div`
  width: 100%;
  position: relative;
  padding-top: 56.25%;
  border-radius: ${theme.token.var('borderRadius.big')};
  overflow: hidden;

  background-color: ${theme.token.var('colors.green.a250')};
`

export const StyledLoader = styled(Loader)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
`

export const Player = styled(ReactPlayer)`
  position: absolute;
  top: 0;
  left: 0;
`

export const IconWrapper = styled.div`
  flex-shrink: 0;
  margin-left: 20px;
  padding: 20px;
  border-radius: ${theme.token.var('borderRadius.big')};

  background-color: ${theme.token.var('colors.green.a200')};
  cursor: pointer;

  @media (max-width: ${theme.token('breakpoints.md')}) {
    position: fixed;
    bottom: 10vh;
    left: 50%;
    transform: translateX(-50%);
    margin: 0;
  }
`
